export default __webpack_public_path__ + "static/media/PRA_Right_Object_Triple 1.9e201128.wav";